import Vue from 'vue'

/**
 * Sort plain or objects array numerically filter
 * @name SortNumeric Utils filter
 * @returns {array} Numerically sorted Array
 */

const sortNumeric = (arrayToSort, sortByKey, orderBy = 'asc') => {

  const isSortable = Array.isArray(arrayToSort)
  const plainStrArray = isSortable && arrayToSort.every((element) => typeof element === 'number')

  if (!isSortable || (!plainStrArray && !sortByKey)) {
    console.warn('[sort-numeric-filter] Unable to numerically sort provided source')

    return arrayToSort
  }

  return arrayToSort.sort((a, b) => {
    const aVal = plainStrArray ? a : a[sortByKey] || ''
    const bVal = plainStrArray ? b : b[sortByKey] || ''

    return orderBy === 'asc' ? aVal - bVal : bVal - aVal
  })
}

Vue.filter('sortNumeric', sortNumeric)

export default sortNumeric
